import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import ExternalLink from "@/components/ExternalLink.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InstanceUrl',
    props: {
        href: { default: null },
        title: { default: null },
        loading: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const effectiveTitle = computed(() => {
            return props.title ? props.title : props.href;
        });
        return { __sfc: true, props, effectiveTitle, ExternalLink, LoadingSpan };
    }
});
